'use client';

import type { ProviderResponse } from '@/app/models/providersResponse';
import { useListAllByPeriodAndProviderQuery, useListAllProviderByPeriodQuery } from '@/app/services/providerApi';
import CollaboratorTable from '@/components/Providers/CollaboratorTable';
import ProviderTable from '@/components/Providers/ProviderTable';
import { usePeriod } from '@/context/PeriodContext';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

function ProvidersDetails() {
  const { selectedPeriod } = usePeriod();
  const { id: idParam } = useParams();
  const id = Number(idParam);

  const { data } = useListAllByPeriodAndProviderQuery(
    {
      date: selectedPeriod?.date as string,
      id,
    },
    { skip: !selectedPeriod },
  );

  const { data: providerData } = useListAllProviderByPeriodQuery(selectedPeriod?.date as string, {
    skip: !selectedPeriod,
  });

  const selected: ProviderResponse | undefined = providerData?.find((item) => item.provider.id === id);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <Box
        sx={{
          mb: 4,
          mt: 1,
        }}
      >
        <ProviderTable header={selected} />
      </Box>

      <CollaboratorTable rows={data || []} />
    </Box>
  );
}

export default ProvidersDetails;
